export default __webpack_public_path__ + "static/media/trustedSaller.9cc77b34.svg";